import {
  LayoutDashboard,
  Inbox,
  Kanban,
  Database,
  ChartNoAxesCombinedIcon,
  Workflow,
  Megaphone,
  Sparkles,
  Users,
  Building2,
  Smartphone,
  Waypoints,
  Handshake,
  Circle,
} from "lucide-react";
import { navItem } from "@touchworks/shared/platform/navigation.js";

/**
 * O ícone de cada item de menu — o mesmo que o menu desenha.
 *
 * O catálogo compartilhado guarda o NOME do ícone, porque a API também o lê e
 * lá não existe React. A resolução para componente mora aqui, e é usada tanto
 * pelo menu quanto pelo cartão de caminho que o Lucas mostra: se o ícone do
 * chat fosse outro, a pessoa varreria a barra lateral procurando o errado.
 */

const NAV_ICON = {
  LayoutDashboard,
  Inbox,
  Kanban,
  Database,
  ChartNoAxesCombinedIcon,
  Workflow,
  Megaphone,
  Sparkles,
  Users,
  Building2,
  Smartphone,
  Waypoints,
  Handshake,
};

/** @param {string} name — o nome guardado no catálogo */
export function navIcon(name) {
  return NAV_ICON[name] || Circle;
}

/** @param {string} key — a chave do item de menu */
export function navIconByKey(key) {
  const item = navItem(key);
  return item ? navIcon(item.icon) : Circle;
}

/** Os itens já com o componente resolvido, para o menu montar a lista. */
export function withIcons(items) {
  return items.map((item) => ({ ...item, icon: navIcon(item.icon) }));
}

export default navIcon;
